import { PureComponent, type ReactNode } from "react";

import { ReviewItemSkeleton } from "@App/Components/Skeletons/ReviewItemSkeleton";

export class ReviewsSkeleton extends PureComponent {
  render(): ReactNode {
    return (
      <section
        id="bewertungen"
        className="container mx-auto my-10 border-t border-neutral-100 pt-10"
      >
        <div className={"text-2xl font-serif mb-5"}>Gesamtbewertung</div>

        <div className="md:flex gap-10 w-full my-10 mb-14">
          <div className={"md:w-1/2 mb-5"}>
            <div className={"text-xl font-serif mb-5"}>Bewertungen von repareo-Kunden</div>
            {[...Array(3)].map((e, i) => (
              <ReviewItemSkeleton key={i} />
            ))}
          </div>

          <div className={"md:w-1/2 mb-5 md:pl-10 md:border-l border-neutral-100"}>
            <div className={"text-xl font-serif mb-5"}>Weitere Bewertungen</div>
            {[...Array(3)].map((e, i) => (
              <ReviewItemSkeleton key={i} />
            ))}
          </div>
        </div>
      </section>
    );
  }
}
